(function () {
  const header = document.querySelector('.am-header');
  if (!header) return;

  const HIDDEN_CLASS = 'am-header--hidden';
  const DELTA_THRESHOLD = 8;
  const TOP_OFFSET = 4;

  const mql = window.matchMedia('(max-width: 767px)');
  const drawerPanel = document.querySelector('[data-am-drawer-panel]');

  let lastY = window.scrollY;
  let hidden = false;
  let ticking = false;

  function isDrawerOpen() {
    return drawerPanel ? !drawerPanel.hidden : false;
  }

  function setHidden(value) {
    if (hidden === value) return;
    hidden = value;
    header.classList.toggle(HIDDEN_CLASS, value);
  }

  function update() {
    ticking = false;

    if (!mql.matches || isDrawerOpen()) {
      setHidden(false);
      lastY = window.scrollY;
      return;
    }

    const y = window.scrollY;
    const delta = y - lastY;

    if (y <= TOP_OFFSET) {
      setHidden(false);
    } else if (Math.abs(delta) >= DELTA_THRESHOLD) {
      setHidden(delta > 0);
    }

    lastY = y;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  mql.addEventListener('change', () => setHidden(false));
})();
